export default __webpack_public_path__ + "static/frost-wipe-51df60b3d8e6cff993a574704882cbca.webm";